import axios from 'axios';

const submissionPath = () => {
  const prefix = (window.I18n?.prefix || '').replace(/\/$/, '');
  return `${prefix ? `/${prefix}` : ''}/api/submissions`;
};

export const postSubmission = (payload) => {
  return axios.post(submissionPath(), {
    submission: payload
  });
};
